export const TOGGLE_VIDEO_SOUND = 'TOGGLE_VIDEO_SOUND';

export const toggleVideoSound = muted => ({
  type: TOGGLE_VIDEO_SOUND,
  payload: {
    muted,
  },
});
